import React, { ReactNode, useEffect } from "react";
import { useAuth } from "@noom/hive-auth";
import {
  getSessionState,
  updateSessionState,
} from "src/pageDefinitions/session";
import { NoomLoader } from "src/components/noom-loader/NoomLoader";

export const IDENTITY_SERVER_CALLBACK_PATH = "/p/login/callback";
export const IDENTITY_SERVER_LOGIN_PATH = "/p/login";

export type InternalLocation = Pick<Location, "pathname" | "search" | "hash">;

declare module "src/pageDefinitions/session" {
  interface BrowserSessionState {
    loginInternalLocation?: InternalLocation;
  }
}

export function getLoginInternalLocation(): InternalLocation | undefined {
  const { loginInternalLocation } = getSessionState("browser");
  return loginInternalLocation;
}

export function clearLoginInternalLocation() {
  updateSessionState("browser", {
    loginInternalLocation: undefined,
  });
}

export function redirectToLogin(location: InternalLocation = window.location) {
  updateSessionState("browser", {
    loginInternalLocation: {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    },
  });
  window.location.replace(IDENTITY_SERVER_LOGIN_PATH);
}

export function AuthGuard({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      redirectToLogin();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return <NoomLoader fullScreen />;
  }
  return <>{children}</>;
}
